import React, { useCallback } from 'react';
import without from 'lodash/without';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useEpicFilters } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/main.tsx';
import { isViewSettingAsPanelExpEnabledWithNoExposure } from '../../../feature-flags.tsx';
import { useIsInsightsPanelOpen } from '../../../state/state-hooks/use-is-insights-panel-open.tsx';
import { useIsViewSettingsPanelOpen } from '../../../state/state-hooks/use-is-view-settings-panel-open.tsx';
import DetailView from '../../detail-view/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../../model/constants.tsx';

type Props = {
	boardId: number;
	parentWidth: number;
	isDetailViewVisible: boolean;
};

export const DetailViewPanel = ({ boardId, parentWidth, isDetailViewVisible }: Props) => {
	const isInsightsPanelOpen = useIsInsightsPanelOpen();
	const isViewSettingsPanelOpen = useIsViewSettingsPanelOpen();
	const [epicFilters, { setEpicFilters }] = useEpicFilters();
	const onBentoDelete = useCallback(
		(issueId: string) => {
			if (epicFilters && epicFilters.includes(issueId)) {
				setEpicFilters(without(epicFilters, issueId));
			}
		},
		[epicFilters, setEpicFilters],
	);
	return isDetailViewVisible ||
		isInsightsPanelOpen ||
		(isViewSettingAsPanelExpEnabledWithNoExposure() && isViewSettingsPanelOpen) ? (
		<DetailView parentWidth={parentWidth} onDelete={onBentoDelete} boardId={boardId} />
	) : null;
};

export const DetailViewPanelWithErrorBoundary = (props: Props) => (
	<JSErrorBoundary
		id="backlogContentDetailView"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
		fallback="flag"
	>
		<DetailViewPanel {...props} />
	</JSErrorBoundary>
);
